import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLottieAnimation } from 'src/hooks/useLottieAnimation';
import CardItem from './CardItem';

function OurValues({ ourValues: { subtitle, title, description, animationData, animationFallbackImage, ourValues } }) {
  const { Animation } = useLottieAnimation({ animationData, fallbackImage: animationFallbackImage });
  return (
    <Container className="py-6">
      <Row id="elkapraztatunk">
        <Col xs={12} md={10} className="mx-auto py-6 text-center ">
          {subtitle && <p className="text-uppercase">{subtitle}</p>}
          <h2 className="py-2 text-black">{title}</h2>
          <div className="text-muted">{description}</div>
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} lg={{ span: 4, order: 0 }} className="py-lg-6">
          {ourValues.slice(0, Math.ceil(ourValues.length / 2)).map((item) => (
            <CardItem key={item._key} item={item} index={ourValues.indexOf(item)} />
          ))}
        </Col>
        <Col xs={{ span: 12, order: 0 }} lg={{ span: 4, order: 1 }} className="py-lg-6">
          <div className="mx-auto mb-3" style={{ maxWidth: '366px' }}>
            <Animation />
          </div>
        </Col>
        <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} lg={{ span: 4, order: 2 }} className="py-lg-6">
          {ourValues.slice(Math.ceil(ourValues.length / 2), ourValues.length).map((item) => (
            <CardItem key={item._key} item={item} index={ourValues.indexOf(item)} />
          ))}
        </Col>
      </Row>
    </Container>
  );
}

export default OurValues;
